import React from 'react';
import { ExcelWidgetConfig } from '../../../../../types';
import { getWidgetIcon } from '../../../registry';

interface ExcelWidgetBuilderProps {
  config: Partial<ExcelWidgetConfig>;
  onChange: (config: ExcelWidgetConfig) => void;
}

const ExcelWidgetBuilder: React.FC<ExcelWidgetBuilderProps> = ({
  config,
  onChange,
}) => {
  // No configuration needed at template level - everything is set at dashboard or assignment level

  return (
    <div className="space-y-4">
      <div className="bg-success-50 border border-success-200 rounded-lg p-4 text-sm text-success-800">
        <strong>Excel Widget Template</strong>
        <p className="mt-1">
          This creates a reusable Excel widget. No configuration is needed here.
        </p>
      </div>

      {/* Info Box */}
      <div className="border rounded-lg p-4 bg-primary-50 border-primary-200">
        <h4 className="font-medium text-primary-800 mb-2 flex items-center gap-2">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          How it works
        </h4>
        <ul className="text-sm text-primary-700 space-y-2 ml-7 list-disc">
          <li>Create this template to make Excel widgets available</li>
          <li>When adding to a dashboard, choose the data source:
            <ul className="ml-4 mt-1 list-disc text-primary-600">
              <li><strong>Dashboard</strong> - Configure a specific file ID</li>
              <li><strong>Workflow</strong> - File ID is set when creating assignments</li>
            </ul>
          </li>
          <li>Workers see the pre-assigned Excel file in their tasks</li>
        </ul>
      </div>

      {/* Preview */}
      <div className="border rounded-lg p-3 bg-surface">
        <label className="block text-sm font-medium text-neutral-700 mb-2">
          Preview
        </label>
        <div className="flex items-center gap-3 p-4 bg-neutral-50 rounded border">
          <span className="text-4xl">{getWidgetIcon('onedrive')}</span>
          <div>
            <p className="font-medium text-neutral-900">Excel Widget</p>
            <p className="text-sm text-neutral-500">
              File configured per dashboard or assignment
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExcelWidgetBuilder;
